/** @format */

export const footwearApparelAttrNames = [
  'color',
  'shoesize',
  'shoewidth',
  'size',
  'inseam',
  'length',
];
